export default "__VITE_ASSET__o3nyWeaE__"